module.exports = __webpack_public_path__ + "img/b3.d35f4bfd.png";